var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.argBool==true)?_c('b-icon',{attrs:{"icon":"check2-circle","aria-hidden":"true","variant":"success"}}):_vm._e(),(_vm.argBool==false)?_c('b-icon',{attrs:{"icon":"x-circle","aria-hidden":"true","variant":"danger"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }